import React from 'react';

export interface TagChipProps {
  label: string;
  /**
   * When provided, the chip renders a remove affordance (×) and calls this
   * on click. Omit for read-only contexts (rows, read-mode detail view).
   */
  onRemove?: (label: string) => void;
}

/**
 * TagChip — a small pill showing a single tag name. Read-only by default;
 * passing `onRemove` adds an inline × for editable contexts. Styled like the
 * mention chip (see `.tag-chip` in global.css, which mirrors `.mention-chip`).
 */
export function TagChip({ label, onRemove }: TagChipProps) {
  if (onRemove) {
    return (
      <span className="tag-chip tag-chip--removable">
        <span className="tag-chip__label">#{label}</span>
        <button
          type="button"
          className="tag-chip__remove"
          aria-label={`Remove tag ${label}`}
          onClick={(e) => {
            e.stopPropagation();
            onRemove(label);
          }}
        >
          &times;
        </button>
      </span>
    );
  }
  return <span className="tag-chip">#{label}</span>;
}
